/**
 * UsageMeter — the cycle's assistant messages (mission 8 WP08 T043; FR-005, FR-012, SAT.5, NFR-010;
 * style guide §7.12; sheet 22 callout 10, sheet 51 callout 10).
 *
 * A caption line, `assistantMeter`, from the one usage read the panel makes on open (U11). At 90 % of
 * the ceiling the read returns it turns `warning-800` and says when the count resets
 * (`assistantMeterWarning`). The ceiling is never a literal here. At the ceiling the panel replaces
 * this meter and the composer with the throttled notice (TR-1; `AssistantPanel`).
 */
import type { AssistantUsage } from '@/lib/api/assistant'
import { date } from '@/lib/format'
import { PROVISIONAL_COPY } from '@/lib/provisional-copy'

/** §7.12: the meter warns at 90 % of the ceiling. */
function nearCeiling({ used, ceiling }: AssistantUsage): boolean {
  return used * 10 >= ceiling * 9
}

export function UsageMeter({ usage }: { usage: AssistantUsage }) {
  const warning = nearCeiling(usage)
  const { used, ceiling } = usage
  return (
    <p
      data-usage-meter=""
      data-level={warning ? 'warning' : 'normal'}
      className={warning ? 'text-caption text-[var(--color-warning-800)]' : 'text-caption text-navy-600'}
    >
      {warning
        ? PROVISIONAL_COPY.assistantMeterWarning.render({ used, ceiling, resetsAt: date(usage.resets_at) })
        : PROVISIONAL_COPY.assistantMeter.render({ used, ceiling })}
    </p>
  )
}
